const ApiUrl = () => {

    let link = '';
    if ( window.location.hostname === 'localhost') {
        link = 'http://localhost/api'
        link = 'https://api.profile.vox.pl/api'
    } else {
        link = 'https://api.profile.vox.pl/api'
    }

    return link;
}

export default ApiUrl;